import React from 'react';
import Switch from '@material-ui/core/Switch';
import Tooltip from '@material-ui/core/Tooltip';
import { withStyles } from '@material-ui/core/styles';

const PurpleSwitch = withStyles({
  switchBase: {
    color: '#A3ADC2',
    '&$checked': {
      color: '#A3ADC2',
    },
    '&$checked + $track': {
      backgroundColor: '#D1D6E0',
    },
  },
  checked: {},
  track: { backgroundColor: '#D1D6E0' },
})(Switch);

const StatsModeToggle = ({ statsMode, setStatsMode }) => (
  <span style={{ display: 'inline-flex', alignItems: 'center', marginLeft: 24 }}>
    <span>Median</span>
    <Tooltip title={statsMode === 'med' ? 'Change to Average' : 'Change to Median'}>
      <PurpleSwitch
        checked={statsMode !== 'med'}
        onChange={() => setStatsMode(statsMode === 'med' ? 'avg' : 'med')}
      />
    </Tooltip>
    <span>Average</span>
  </span>
);

export default StatsModeToggle;
